import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import AppButton from "../../../../../views/components/common/buttons/AppButton";
import FormTextField from "../../../../../views/components/common/form/FormTextField";
import AppDropDown from "../../../../../views/components/common/filter/AppDropDown";
import { FilterValue } from "../../../../../models/Filters/FilterValue";
import { Currencies } from "../../../../../models/Order/OrderCurrencies";

interface ExchangeRatePopupProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: { currency: string; exchangeRate: number }) => void;
}

const ExchangeRatePopup: React.FC<ExchangeRatePopupProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [currency, setCurrency] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");

  const handleSave = () => {
    if (currency && exchangeRate) {
      onSave({ currency, exchangeRate: parseFloat(exchangeRate) });
      onClose();
    }
  };

  const handleCancel = () => {
    setCurrency("");
    setExchangeRate("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}      
      fullWidth
      sx={{
        maxWidth: "500px",
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DialogTitle
        sx={{
          pt: 3,
          whiteSpace: "nowrap",
          overflow: "visible",
        }}
      >
        Select Currency and Exchange Rate
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          display="flex"
          flexDirection="column"
          gap={4}
          mt={2}
        >
          <AppDropDown
            title="Select Currency"
            isMultiSelect={false}
            list={Currencies.map((option) => {
              let filter = {
                id: String(option.value),
                value: option.label,
              } as FilterValue;
              return filter;
            })}
            height="36px"
            listHeight="30px"
            fontSize="14px"
            value={currency}
            onSingleSelectionChange={(id) => {
              setCurrency(id);
            }}
          />

          <FormTextField
            id="exchangeRate"
            type="number"
            label="Exchange Rate"
            value={exchangeRate}
            onChange={(id, value) => {
              if (value !== undefined) {
                setExchangeRate(value);
              }
            }}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "end" }}>
          <AppButton
            onClick={handleCancel}
            variant="grayscale"
            label="Cancel"
          />
          <AppButton onClick={handleSave} variant="primary" label="Save" />
        </Box>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default ExchangeRatePopup;
